import { render, staticRenderFns } from "./app.vue?vue&type=template&id=ff44f5d4"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"
import style0 from "./app.vue?vue&type=style&index=0&id=ff44f5d4&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff44f5d4')) {
      api.createRecord('ff44f5d4', component.options)
    } else {
      api.reload('ff44f5d4', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=ff44f5d4", function () {
      api.rerender('ff44f5d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/app.vue"
export default component.exports